import React, { useEffect, useState } from "react";
import { IConsumptionTaxState } from "../../../models/state/IMasterSettingsState";
import { IAddSaleItemVM, IDiscountType, ISaleRecordList, ISaleRecordPaymentInvoiceDetails } from "../../../models/response/ISMRResponse";
import { IOption } from "../../../models/ICommon";
import { calculateSummary, formatNumberWithCommas } from "../../../constants/constants";
import { formatMessage } from "../../../translations/format-message";
import { FormattedMessage } from "react-intl";

interface IProps {
  saleItems: IAddSaleItemVM[];
  consumptionTax: IConsumptionTaxState;
  overAllDiscountDetails: IDiscountType;
  getAllStaffOptions: IOption[];
  saleRecordItem: ISaleRecordList;
  isDataChanged: boolean;
  onRemoveDiscount?: () => void;
  mainStaff:{StaffId:number, IsNominationApplied:boolean};
}
const SaleRecordPaymentInvoice = (props: IProps) => {
  const { saleItems, consumptionTax, overAllDiscountDetails, getAllStaffOptions, saleRecordItem, isDataChanged, mainStaff } = props;
  const [invoiceDetails, setInvoiceDetails] = useState<ISaleRecordPaymentInvoiceDetails>({
    Subtotal:0,
    NominationFee:0,
    TaxTotal:0,
    OverAllDiscount:0,
    TaxBreakdown:{},
    ConsumptionTax:0,
    TotalAmount:0,
  }) 
  
  const handleRemoveDiscount = () => {
    props.onRemoveDiscount?.();
  };

  useEffect(() => {
    const result = calculateSummary(mainStaff, saleItems, getAllStaffOptions, consumptionTax, overAllDiscountDetails, isDataChanged, saleRecordItem.NominationFee);
    setInvoiceDetails(result);
  }, [saleItems, overAllDiscountDetails, mainStaff ]);
  
  return (
    <div>
      <div className="p-3">
        <div className="row mb-2">
          <div className="col-md-6 col-12 text-end pe-5">
            <FormattedMessage id="subtotal_smr" />:
          </div>
          <div className="col-md-6 col-12"><i className="bi bi-currency-yen me-1"></i> {formatNumberWithCommas(invoiceDetails.Subtotal)}</div>
        </div>
        <div className="row mb-2">
          <div className="col-md-6 col-12 text-end pe-5">
            <FormattedMessage id="nomination_fee_smr" />(<FormattedMessage id="excluding_tax_smr" />):
          </div>
          <div className="col-md-6 col-12"><i className="bi bi-currency-yen me-1"></i> {formatNumberWithCommas(invoiceDetails.NominationFee)}</div>
        </div>
        {/* <div className="row mb-2">
          <div className="col-md-6 col-12 text-end pe-5">
            <FormattedMessage id="overall_discount" />:
          </div>
          <div className="col-md-6 col-12">
            {" "}
            {invoiceDetails.OverAllDiscount > 0 ? (
              <small className="px-2 py-1 rounded text-white bg-primary">
                <i className="bi bi-tags-fill me-2"></i>
                <i className="bi bi-currency-yen me-1"></i>
                {formatNumberWithCommas(invoiceDetails.OverAllDiscount)}
                {overAllDiscountDetails.DiscountType == 0 && (
                  <> ({overAllDiscountDetails.DiscountPercent} %)</>
                )}
                {overAllDiscountDetails.DiscountType == 2 && (
                  <>
                    ({overAllDiscountDetails.DiscountPercent} % ,{" "}
                    {formatNumberWithCommas(overAllDiscountDetails.DiscountCash)}円)
                  </>
                )}
                <button
                  type="button"
                  className="btn-close btn-close-white btn-sm ms-2"
                  aria-label="Remove"
                  onClick={handleRemoveDiscount}
                ></button>
              </small>
            ) : <>
            <i className="bi bi-currency-yen me-1"></i>
            {formatNumberWithCommas(invoiceDetails.OverAllDiscount) }
            </>
            }
          </div>
        </div> */}
        <div className="row mb-2">
          {Object.entries(invoiceDetails.TaxBreakdown).map(
            ([taxRate, value]) => (
              <>
                <div className="col-md-6 col-12 text-end pe-5">
                  (<FormattedMessage id="subject_to" />{taxRate}<FormattedMessage id="tax_smr" />):
                </div>
                {/* <div className="col-md-6 col-12"> {value.toFixed(2)}</div> */}
                <div className="col-md-6 col-12"><i className="bi bi-currency-yen me-1"></i> {formatNumberWithCommas(value)}</div>
              </>
            )
          )}
        </div>
        {
          invoiceDetails.NominationFee > 0 &&
          <>
            {!Object.keys(invoiceDetails?.TaxBreakdown || {}).some(
              (key) =>
                parseFloat(key.replace("%", "")) ===
                parseFloat(props.consumptionTax?.TaxValue?.toString() || "0")
            ) && (
              <div className="row mb-2">
                <div className="col-md-6 col-12 text-end pe-5">
                  (<FormattedMessage id="subject_to" />{props.consumptionTax?.TaxValue}% <FormattedMessage id="consumption_tax_smr" />):
                </div>
                <div className="col-md-6 col-12">
                  <i className="bi bi-currency-yen me-1"></i> {formatNumberWithCommas(invoiceDetails.ConsumptionTax)}
                </div>
              </div>
            )}
          </>
        }

        <div className="row mb-2">
          <div className="col-md-6 col-12 text-end pe-5">
            <FormattedMessage id="total_smr" />:
          </div>
          <div className="col-md-6 col-12">
            <i className="bi bi-currency-yen me-1"></i> {formatNumberWithCommas(saleRecordItem.SaleRecordPaymentStatus === true && saleRecordItem.PaymentType === 0 ? 0 : invoiceDetails.TotalAmount)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SaleRecordPaymentInvoice;
